import { EntityType } from '@shared/models/entity-enum';

/*** Details Tab Actions ***/
export enum PropertyDetailsTabId {
  Details = 120,
  Availabilities = 121,
  Comps = 122,
  StackingPlan = 123,
  Tenants = 124,
  Attachments = 125,
  HistoricalStats = 126,
  AuditHistory = 127,
}

export enum TIMDetailsTabId {
  Details = 149,
  AuditHistory = 150,
}

export enum DetailsTabId {}

export const EnabledTrackingTabActionByEntity = {
  [EntityType.Property]: true,
  [EntityType.Tim]: true,
};

export const DetailsTabActionNameByTabId = Object.freeze({
  [PropertyDetailsTabId.Details]: 'Clicks Details Tab',
  [PropertyDetailsTabId.Availabilities]: 'Clicks Availabilities Tab',
  [PropertyDetailsTabId.Comps]: 'Clicks Comps Tab',
  [PropertyDetailsTabId.StackingPlan]: 'Clicks Stacking Plan Tab',
  [PropertyDetailsTabId.Tenants]: 'Clicks Tenants Tab',
  [PropertyDetailsTabId.Attachments]: 'Clicks Attachments Tab',
  [PropertyDetailsTabId.HistoricalStats]: 'Clicks Historical Stats Tab',
  [PropertyDetailsTabId.AuditHistory]: 'Clicks Audit History Tab',
  [TIMDetailsTabId.Details]: 'Clicks Details Tab',
  [TIMDetailsTabId.AuditHistory]: 'Clicks Audit History Tab',
});
/*** Details Tab Actions ***/

/** Details Page Actions ***/

export const EnabledTrackingDetailsPageAction = {
  [EntityType.Property]: true,
  [EntityType.Tim]: true,
};

export enum DetailsPageActionKeys {
  SelectUsage = 260, // Clicks Select Usage
  AddUsage = 261, // Clicks Add Usage
  ToggleFavoriteColumns = 262, // Clicks Toggle Favorites
  ToggleSidePanelLocation = 263, // Clicks Toggle Side Panel Location
  CompleteTIM = 264, // Clicks Complete TIM
}
/*** Details Page Actions ***/
